import axios from 'axios'
import store from '../store'
import config from '@/helpers/config'

export default {
  getUserById (context, payload) {
    return axios.get(
      config.apiUrl + '/admin/users/by-id/with-all/' + payload + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUserByEmail (context, payload) {
    return axios.get(
      config.apiUrl + '/admin/users/by-email/with-all/' + payload + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCountries (context, payload) {
    return axios.get(
      config.apiUrl + '/location/countries/uuid/' + payload + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCountriesByIds (context, payload) {
    return axios.get(
      config.apiUrl + '/location/countries-by-ids/uuid/' + payload.projectUuid + payload.query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCountriesBySearchValue (context, payload) {
    return axios.get(
      config.apiUrl + '/location/countries/uuid/' + payload.projectUuid + '/fuzzy/' + payload.searchValue + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getStates (context, payload) {
    return axios.get(
      config.apiUrl + '/location/states/uuid/' + payload + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getStatesByIds (context, payload) {
    return axios.get(
      config.apiUrl + '/location/states-by-ids/uuid/' + payload.projectUuid + payload.query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getStatesBySearchValue (context, payload) {
    return axios.get(
      config.apiUrl + '/location/states/uuid/' + payload.projectUuid + '/fuzzy/' + payload.searchValue + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCities (context, payload) {
    return axios.get(
      config.apiUrl + '/location/cities/uuid/' + payload + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCitiesByIds (context, payload) {
    return axios.get(
      config.apiUrl + '/location/cities-by-ids/uuid/' + payload.projectUuid + payload.query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCitiesBySearchValue (context, payload) {
    return axios.get(
      config.apiUrl + '/location/cities/uuid/' + payload.projectUuid + '/fuzzy/' + payload.searchValue + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getLanguages (context, payload) {
    return axios.get(
      config.apiUrl + '/location/languages/uuid/' + payload + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getLanguagesByIds (context, payload) {
    return axios.get(
      config.apiUrl + '/location/languages-by-ids/uuid/' + payload.projectUuid + payload.query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getLanguagesBySearchValue (context, payload) {
    return axios.get(
      config.apiUrl + '/location/languages/uuid/' + payload.projectUuid + '/fuzzy/' + payload.searchValue + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweets (context, payload) {
    return axios.get(
      config.apiUrl + '/twitter/tweets' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsWithImpressions (context, payload) {
    return axios.get(
      config.apiUrl + '/twitter/tweets/with-impressions' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsCount (context, payload) {
    return axios.get(
      config.apiUrl + '/twitter/tweets/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsTypesCount (context, payload) {
    return axios.get(
      config.apiUrl + '/twitter/tweets/types/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsByCountries (context, payload) {
    return axios.get(config.apiUrl + '/twitter/countries' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsByCities (context, payload) {
    return axios.get(config.apiUrl + '/twitter/cities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsByLanguages (context, payload) {
    return axios.get(config.apiUrl + '/twitter/languages' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersCount (context, payload) {
    return axios.get(config.apiUrl + '/twitter/users/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersByCountries (context, payload) {
    return axios.get(config.apiUrl + '/twitter/users/countries' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersByCities (context, payload) {
    return axios.get(config.apiUrl + '/twitter/users/cities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getImpressionsCount (context, payload) {
    return axios.get(config.apiUrl + '/twitter/tweets/impressions/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getArticlesCount (context, payload) {
    return axios.get(config.apiUrl + '/news/articles/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTwitterCountriesCount (context, payload) {
    return axios.get(config.apiUrl + '/twitter/countries/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtags (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtagsWithStats (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/with-stats' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtagsCount (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtagsWithRelatedTags (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/with-related-tags' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getVirtualHashtagsWithRelatedTags (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/virtual-with-related-tags' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtagsByCountries (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/countries' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtagsByCities (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/cities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getEmojis (context, payload) {
    return axios.get(config.apiUrl + '/twitter/emojis' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getEmojisByCountries (context, payload) {
    return axios.get(config.apiUrl + '/twitter/emojis/countries' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getEmojisByCities (context, payload) {
    return axios.get(config.apiUrl + '/twitter/emojis/cities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsVolume (context, payload) {
    return axios.get(config.apiUrl + '/twitter/tweets/volume' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsTypesVolume (context, payload) {
    return axios.get(config.apiUrl + '/twitter/tweets/types/volume' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getHashtagsVolume (context, payload) {
    return axios.get(config.apiUrl + '/twitter/hashtags/volume' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getNewsSources (context, payload) {
    return axios.get(config.apiUrl + '/news/sources' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getTwitterContributors (context, payload) {
    return axios.get(config.apiUrl + '/twitter/users' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getTwitterUsersWithQtsandRts (context, payload) {
    return axios.get(config.apiUrl + '/twitter/users/with-rts-and-qts' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getArticleById (context, payload) {
    return axios.get(config.apiUrl + '/news/article/' + payload.id + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getArticles (context, payload) {
    return axios.get(config.apiUrl + '/news/articles' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getArticlesVolume (context, payload) {
    return axios.get(config.apiUrl + '/news/articles/volume' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getDomains (context, payload) {
    return axios.get(config.apiUrl + '/news/domains' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getDomainsCount (context, payload) {
    return axios.get(config.apiUrl + '/news/domains/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getStories (context, payload) {
    return axios.get(config.apiUrl + '/news/stories' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getStoriesWithArticles (context, payload) {
    return axios.get(config.apiUrl + '/news/stories/with-articles' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getStoriesWithLimitedArticles (context, payload) {
    return axios.get(config.apiUrl + '/news/stories/with-limited-articles' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getStoriesCount (context, payload) {
    return axios.get(config.apiUrl + '/news/stories/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTwitterSentiment (context, payload) {
    return axios.get(config.apiUrl + '/twitter/sentiment' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getNewsLanguage (context, payload) {
    return axios.get(config.apiUrl + '/news/language' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getNewsSentiment (context, payload) {
    return axios.get(config.apiUrl + '/news/sentiment' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getTwitterSentimentEvolution (context, payload) {
    return axios.get(config.apiUrl + '/twitter/sentiment/evolution' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getNewsSentimentEvolution (context, payload) {
    return axios.get(config.apiUrl + '/news/sentiment/evolution' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getTweetsTopics (context, payload) {
    return axios.get(config.apiUrl + '/nlp/tweets-topics' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getArticlesTopics (context, payload) {
    return axios.get(config.apiUrl + '/nlp/articles-topics' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getEntitiesCount (context, payload) {
    return axios.get(config.apiUrl + '/nlp/entities/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getEntityTypesCount (context, payload) {
    return axios.get(config.apiUrl + '/nlp/entities/types/count' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getTweetsEntities (context, payload) {
    return axios.get(config.apiUrl + '/nlp/tweets-entities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getTweetsEntitiesVolume (context, payload) {
    return axios.get(config.apiUrl + '/nlp/tweets-entities/volume' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsEntitiesWithRelatedEntities (context, payload) {
    return axios.get(config.apiUrl + '/nlp/tweets-entities/with-related-entities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTweetsVirtualEntitiesWithRelatedEntities (context, payload) {
    return axios.get(config.apiUrl + '/nlp/tweets-entities/virtual-with-related-entities' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getTwitterSentimentCountry (context, payload) {
    return axios.get(config.apiUrl + '/twitter/sentiment/by-country' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  getNewsSentimentCountry (context, payload) {
    return axios.get(config.apiUrl + '/news/sentiment/by-country' + payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromTweet (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromTweetCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/count/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromTweet (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromTweetCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/count/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromTweet (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromTweetCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/count/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromTweet (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromTweetCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/count/from/tweet' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromArticle (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromArticleCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/count/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromArticle (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromArticleCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/count/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromArticle (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromArticleCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/count/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromArticle (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromArticleCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/count/from/article' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromHashtag (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromHashtagCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/count/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromHashtag (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromHashtagCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/count/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromHashtag (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromHashtagCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/count/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromHashtag (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromHashtagCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/count/from/hashtag' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromEntity (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getTweetsBacktrackerFromEntityCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/tweets/count/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromEntity (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getArticlesBacktrackerFromEntityCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/articles/count/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromEntity (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getHashtagsBacktrackerFromEntityCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/hashtags/count/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromEntity (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  async getEntitiesBacktrackerFromEntityCount (context, payload) {
    return axios.get(config.apiUrl + '/backtracker/entities/count/from/entity' + payload,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  updateUserActivityType (context, payload) {
    return axios.put(config.apiUrl + '/twitter/user/' + payload.userId + '/' + payload.activityType + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  deleteTweetById (context, payload) {
    return axios.delete(config.apiUrl + '/twitter/tweet/' + payload.id + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  deleteUserById (context, payload) {
    return axios.delete(config.apiUrl + '/twitter/user/' + payload.id + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  deleteArticleById (context, payload) {
    return axios.delete(config.apiUrl + '/news/article/' + payload.id + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  deleteStoryById (context, payload) {
    return axios.delete(config.apiUrl + '/news/story/' + payload.id + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  },
  deleteStoryArticle (context, payload) {
    return axios.delete(config.apiUrl + '/news/story/' + payload.storyId + '/article/' + payload.articleId + payload.query,
    { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js